import dayjs from 'dayjs';
import 'dayjs/locale/id';

dayjs.locale('id');

const IndoDate = (d, time) => {
  const hari = `${dayjs(d).format('dddd')}, ${dayjs(d).format(
    `DD MMM YYYY ${time ? ', HH:mm WIB' : ''}`,
  )}`;

  return hari;
};

export default IndoDate;
